
export const PageHeader = ({ 
  icon: Icon, 
  title, 
  subtitle, 
  iconGradient = "from-blue-600 to-indigo-600"
}) => (
  <div className="text-center mb-12">
    <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${iconGradient} rounded-2xl mb-6 shadow-lg`}>
      <Icon className="w-10 h-10 text-white" />
    </div>
    <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
      {title}
    </h1>
    <p className="text-lg text-slate-600 max-w-3xl mx-auto">
      {subtitle}
    </p>
  </div>
);